import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Appointment from '../sections/Appointment/Appointment';
import Banner from '../sections/Banner/Banner';
import Footer from '../sections/Footer/Footer';
import Services from '../sections/Services/Services';
import Testimonial from '../sections/Testimonial/Testimonial';
import CompanyPartners from '../sections/CompanyPartners/CompanyPartners';
import Achievements from '../sections/Achievements/Achievements';
import AboutCompany from '../sections/AboutCompany/AboutCompany';




const Home = () => {

    return (
        <>
            <Navbar/>
            <Banner/>
            <AboutCompany/>
            <Services/>
            <Achievements/>
            <CompanyPartners />
            <Testimonial/>
            <Appointment/>
            <Footer/>
        </>
    );
};

export default Home;